import * as posedetection from "@tensorflow-models/pose-detection";
import {GameBase} from "./GameBase";
import Matter from "matter-js"

export class SandBug extends GameBase {
  constructor() {
    super();

    this.poseMode = posedetection.SupportedModels.BlazePose
    this.handMode = true
    this.init = false
  }

  initPhysics(w, h, offsetX, offsetY) {
    this.width = w
    this.height = h

    // TODO 外から渡す
    const canvas = document.getElementById('physics-canvas')

    const ctx = canvas.getContext('2d')
    console.log(offsetX)
    ctx.translate(offsetX, offsetY);
    this.offsetX = offsetX

    var Engine = Matter.Engine,
      Render = Matter.Render,
      Runner = Matter.Runner,
      Bodies = Matter.Bodies,
      Composite = Matter.Composite;

    var engine = Engine.create();

    var render = Render.create({
      canvas,
      engine: engine,
      options: {
        width: w,
        height: h,
        background: 'transparent',
        wireframeBackground: 'transparent',
        wireframes: false
      }
    });

    this.boxA = Bodies.circle(400, 200, 80, { restitution: 1, density: 0.001 });
    this.boxB = Bodies.rectangle(450, 50, 80, 80);
    this.boxC = Bodies.rectangle(0, 0, 80, 80, {
      isStatic: true,
      render: {
        // fillStyle: 'transparent',
        // strokeStyle: 'transparent',
      }
    });
    var ground = Bodies.rectangle(w*0.5, h, w, 100, { isStatic: true });
    var ceil = Bodies.rectangle(w*0.5, 0, w, 100, { isStatic: true });
    var wall1 = Bodies.rectangle(w, h*0.5, 100, h, { isStatic: true });
    var wall2 = Bodies.rectangle(0, h*0.5, 100, h, { isStatic: true });

    Matter.Events.on(engine, 'collisionStart', (event) => {
      var collision = Matter.SAT.collides(this.boxB, this.boxC);
      if (collision && collision.collided) {
        // console.log("!!!b")
        // do something
      }
    });

    var maxRopeLength = 150;

    var rock1 = Bodies.polygon(w*0.5, 0, 8, 20, { density: 0.04, isStatic: true }),
      rock2 = Bodies.rectangle(w*0.5, 100, 100, 500, { density: 3 }),
      anchor = { x: w*0.5, y: 100 },
      elastic = Matter.Constraint.create({
        pointA: anchor,
        bodyB: rock1,
        stiffness: 1
      }),
      rope = Matter.Constraint.create({
        bodyA: rock1,
        bodyB: rock2,
        pointB: {x: 0, y: -245},
        length: maxRopeLength,
        stiffness: 0.5
      });
    rope.sqrLength = maxRopeLength * maxRopeLength;

    let list = [this.boxA, this.boxB, ground,ceil,wall1,wall2, this.boxC, rock1, rock2, elastic, rope]
    Composite.add(engine.world, list);

    Render.run(render);
    var runner = Runner.create();
    Runner.run(runner, engine);

    // CameraRenderと同じタイミングだとこの後のsetPositionで左右反転が必要になる
    // ここでoffsetをtransla
    ctx.translate(this.width, 0)
    ctx.scale(-1, 1)
  }

  mainLoop({ pose, hands }) {
    this.p = hands.find(h => h.handedness === "Left")
    // this.p = pose[0]
    if (!this.p) {
      Matter.Body.setPosition(this.boxC, Matter.Vector.create(this.width, this.height))
      this.prePos = null
    } else {
      // Matter.Body.setPosition(this.boxC, Matter.Vector.create(this.width - this.right.keypoints[8].x - offsetX, this.right.keypoints[8].y))
      // const x = this.width - this.p.keypoints[16].x - offsetX
      const pos = this.p.keypoints[8]
      pos.x += this.offsetX
      Matter.Body.setPosition(this.boxC, pos)
      // if (this.prePos) {
      //   Matter.Body.translate(this.boxC, { x: x - this.prePos.x, y: this.prePos.y - y })
      // } else {
      //   Matter.Body.setPosition(this.boxC, {x,y})
      // }
      // this.prePos = { x, y }
    }
  }

  renderCamera(ctx, { pose, hands }) {
  }
}



// WEBPACK FOOTER //
// ./src/components/game/SandBug.js